import React from 'react';
import PropTypes from 'prop-types';
import CwTextField from '../cwtextfield/CwTextField';
import { AlignmentEnum } from '../../utils/Enums';
import { Includes } from '../..//utils/PolyFillFunctions';
import moment from 'moment';

const INVALID_HOUR = "INVALID_HOUR";
const INVALID_MINUTE = "INVALID_MINUTE";
const VALID_HOUR_INVALID_MINUTE = "VALID_HOUR_INVALID_MINUTE";

class CwTimeField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      value: props.value ? this.props.formatTime(props.value) : '',
      regex: props.regex ? props.regex : '^([\b0-9aApPmM.: ])*$'
    };
    this._typing = false;
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.value && this._typing) {
      //Do nothing, let prop slide down, don't get caught by else statement
    } else if (nextProps.value && !this._typing) {
      this.setState({
        value: this.props.formatTime(nextProps.value)
      });
    } else {
      this.setState({
        value: '',
      });
    }

    if (this.props.onComponentWillReceiveProps) {
      this.props.onComponentWillReceiveProps(nextProps);
    }
  }

  onValueChange = (value) => {

    if (!value) {
      this.setState({
        value: ''
      });
      this.props.onChange(null);
      return;
    }

    //only allow one ':'
    if (Includes(value, ":")) {
      if (value.match(/[:]/g).length !== 1 || value.substring(0, value.indexOf(":")).length > 2) {
        return;
      }
    }

    //Only allow up to 3 '.' 
    if (Includes(value, ".")) {
      if (value.match(/[.]/g).length > 3) {
        return;
      }
      if (!Includes(value.toLowerCase(), 'a') && !Includes(value.toLowerCase(), 'p')) {
        if (value.match(/[.]/g).length > 1 || value.substring(0, value.indexOf(".")).length > 2) {
          return;
        }
      }
    }

    //Don't allow more than 4 number
    const timeNumber = this.getPureTime(value).replace(/[^\d]/g, '');;
    if (timeNumber.length > 4) {
      return;
    }

    //Don't allow more than one 'a', 'p', or 'm' and don't allow p when a is present or vice versa
    if (Includes(value.toLowerCase(), 'a')) {
      if (Includes(value.toLowerCase(), 'p') || value.match(/[aA]/g).length !== 1) {
        return;
      }
    }

    if (Includes(value.toLowerCase(), 'p')) {
      if (value.match(/[pP]/g).length !== 1) {
        return;
      }
    }

    if (Includes(value.toLowerCase(), 'm')) {
      if ((!Includes(value.toLowerCase(), 'p') && !Includes(value.toLowerCase(), 'a')) || value.match(/[mM]/g).length !== 1) {
        return;
      }
    }

    const checkedTime = this.checkForValidValues(value);

    if (checkedTime === INVALID_HOUR || checkedTime === INVALID_MINUTE) {
      return;
    } else if (checkedTime === VALID_HOUR_INVALID_MINUTE) {
      this.setState({
        value: value,
      });
      return;
    } else if (checkedTime) {
      this.setState({
        value: value
      });
      this.props.onChange(checkedTime);
      return;
    }

    this.setState({
      value: value
    });

    this.props.onChange(null);

  };

  /**
   * Format the date object to a string on blur and set the Display value to that string
   */
  handleBlur = () => {
    this._typing = false;
    if (this.state.value === '24') {
      this.setState({
        value: ''
      });
      this.props.onChange(null);
      if (this.props.onBlur) {
        this.props.onBlur();
      }
      return;
    };
    const checkedTime = this.checkForValidValues(this.state.value);

    if (checkedTime === INVALID_HOUR || checkedTime === INVALID_MINUTE || checkedTime === VALID_HOUR_INVALID_MINUTE) {
      this.setState({
        value: ''
      });
      this.props.onChange(null);
    } else if (checkedTime) {
      this.setState({
        value: this.props.formatTime(checkedTime)
      });
    } else {
      this.setState({
        value: ''
      });
    }
    if (this.props.onBlur) {
      this.props.onBlur(checkedTime);
    }
  };

  handleFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  handleKeyDown = () => {
    this._typing = true;

    if (this.props.onKeyDown) {
      this.props.onKeyDown();
    }
  }

  getPureTime = (value) => {
    return value.replace(/[^\d.:]/g, '');
  }

  checkForValidValues = (time) => {
    if (time) {
      let hourFlag = false;
      let leadingZeroFlag = false;
      let amFlag;
      const amPm = time.replace(/[\d.:]/g, '').toLowerCase();
      amFlag = Includes(amPm, 'a') ? true : false;
      const pmFlag = Includes(amPm, 'p') ? true : false;
      const pureTime = this.getPureTime(time);

      let hours;
      if (Includes(pureTime, ":")) {
        hours = pureTime.substring(0, pureTime.indexOf(":"));
      } else if (Includes(pureTime, ".")) {
        hours = pureTime.substring(0, pureTime.indexOf("."));
      } else {
        hours = pureTime;
      }

      if (hours.length === 3) {
        const hourFlagCheck = parseFloat(hours.substring(0, 2));
        hours = hours.charAt(0);
        if (hours === '0') {
          leadingZeroFlag = true;
        }
        if (hourFlagCheck > 12 && hourFlagCheck < 24) {
          hourFlag = true;
        }
      } else if (hours.length >= 4) {
        hours = hours.substring(0, 2);
      } else if (hours.length === 2 && !Includes(pureTime, ':') && (!Includes(pureTime, "."))) {
        const hoursNum = parseFloat(hours);

        if (hoursNum > 23) {

          const validMinute = parseFloat(hours.charAt(1)) > 5 ? false : true;
          if (!validMinute) {
            return INVALID_HOUR;
          }
          hours = hours.charAt(0);
        } else {
          hours = hoursNum.toString();
        }
      }

      let minutes;

      if (pureTime.length > 2) {
        if (Includes(pureTime, ":")) {
          minutes = pureTime.substring(pureTime.indexOf(":"));
          if (parseFloat(minutes.charAt(1)) > 5) {
            return INVALID_MINUTE;
          }
        } else if (Includes(pureTime, ".")) {
          minutes = pureTime.substring(pureTime.indexOf("."));
          if (parseFloat(minutes.charAt(1)) > 5) {
            return INVALID_MINUTE;
          }
        } else if (pureTime.length === 3 && pureTime.charAt(0) === '0') {
          if (pureTime.charAt(2) >= 6) {
            return INVALID_MINUTE;
          } else if (pureTime.charAt(1) >= 6) {
            minutes = pureTime.charAt(2);
            hours = pureTime.charAt(1);
          } else {
            minutes = pureTime.substring(pureTime.length - 2);
          }
        } else {
          minutes = pureTime.substring(pureTime.length - 2);
        }

        if ((Includes(minutes, ":") || Includes(minutes, ".")) && minutes.length === 2) {
          minutes += "0";
        }
      }

      minutes = minutes ? minutes.replace(/[^\w]/g, '') : undefined;

      const hoursNum = parseFloat(hours);
      const minuteNum = parseFloat(minutes);

      if (hoursNum) {
        if (hoursNum === 0) {
          hours = '0';
        } else if (hoursNum === 12 && amFlag) { // 12am
          hours = '0';
        } else if (hoursNum >= 1 && hoursNum <= 6 && !amFlag && !this.props.is24HourFormat) { // Hours 1-6 should be considered pm
          hours = hoursNum + 12 + '';
        } else if (hoursNum < 12 && pmFlag) { // honor if explicitly set to pm
          hours = hoursNum + 12 + '';
        } else if (hoursNum > 23) {
          return INVALID_HOUR;
        }
      }

      if ((minuteNum < 0 || minuteNum > 59) && !hourFlag && !leadingZeroFlag) {
        return INVALID_MINUTE;
      } else if (hourFlag || leadingZeroFlag) {
        const validMinute = parseFloat(minutes.charAt(0)) > 5 ? false : true;
        if (!validMinute) {
          return INVALID_MINUTE;
        }
      }

      const validMinute = minutes ? (parseFloat(minutes.charAt(0)) < 6) : undefined;

      if (minutes && hours && validMinute) {
        const momentDate = moment({ hour: hours, minute: minutes });
        return momentDate;
      }

      if (hours) {
        if (minutes && !validMinute) {
          return VALID_HOUR_INVALID_MINUTE;
        }
        const momentDate = moment({ hour: hours, minute: 0 });
        return momentDate;
      }
    }
    return undefined;
  };

  render() {
    return (
      <CwTextField
        ref={(item) => this.timeField = item}
        cwId={this.props.cwId}
        value={this.state.value}
        onChange={this.onValueChange}
        regex={this.state.regex}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        maxLength={this.props.maxLength}
        placeholder={this.props.placeholder}
        readOnly={this.props.readOnly}
        onKeyPress={this.props.onKeyPress}
        tabIndex={this.props.tabIndex}
        invalid={this.props.invalid}
        disabled={this.props.disabled}
        id={this.props.id}
        onKeyDown={this.handleKeyDown}
        onKeyUp={this.props.onKeyUp}
        autoFocus={this.props.autoFocus}
        textAlignment={this.props.textAlignment ? this.props.textAlignment : this.props.inAGrid ? AlignmentEnum.RIGHT : undefined}
        style={this.props.style}
      />
    );
  }

}

CwTimeField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * A function that formats the date time object. Should, at the very minmimum call the .toLocalDateString method
   * from the date object
   */
  formatTime: PropTypes.func.isRequired,
  /**
   * Our initial date, can be null
   */
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  /**
  * Hint text, displayed when user has not typed anything in
  */
  placeholder: PropTypes.string,
  /**
   * Used to set textfield to a read only mode
   */
  readOnly: PropTypes.bool,
  /**
   * Callback function that is fired when textfield's text changes
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired when any key is pressed
   */
  onKeyPress: PropTypes.func,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: PropTypes.number,
  /**
   * Used to control if text is valid
   */
  invalid: PropTypes.bool,
  /**
   * Used to disable textfield
   */
  disabled: PropTypes.bool,
  /**
   * Used as an identifier for the component
   */
  id: PropTypes.string,
  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: PropTypes.string,
  /**
   * Callback function that is fired when textfield is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when textfield is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Callback function that is fired on key down
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback function that is fired on mouse click
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired on key up
   */
  onKeyUp: PropTypes.func,
  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: PropTypes.number,
  /**
   * Used to control if textfield is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * An override for text alignments. Checks 'CENTER' and 'RIGHT' as arguments.
   * Will default to left otherwise or if left blank.
   */
  textAlignment: PropTypes.oneOf([AlignmentEnum.CENTER, AlignmentEnum.RIGHT]),
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * Call back function to hook into ComponentWillReceiveProps
   */
  onComponentWillReceiveProps: PropTypes.func,
  /**
   * True if using 24 hour format instead of AM/PM format
   * Note that this flag is not for formatting the time on the field. formatTime prop handles the formatting.
   * This flag simply toggles the logic to automatically convert hours 1-6 as PM hours in AM/PM format
   * If in 24 hour format, we do not wish to convert hours.
   */
  is24HourFormat: PropTypes.bool,
};

export default CwTimeField;


// WEBPACK FOOTER //
// ./src/components/cwtimefield/CwTimeField.jsx